import { Account, AccountTeam, useGetAccountQuery } from "@/entities/account";
import { TeamPlayerRoles, TeamTags } from "@/entities/teams";
import { TournamentDetails } from "@/entities/tournaments";
import { useMemo } from "react";

export type UserSummary = {
  account?: Account;
  currentTeam?: AccountTeam;
  isCaptain: boolean;
  isLoading: boolean;
};

export function useUserSummary(tournamentId?: number, teamId?: number): UserSummary {
  const { data: account, isLoading } = useGetAccountQuery();

  const currentTeam = useMemo<AccountTeam | undefined>(() => {
    if (account && tournamentId) {
      return account.teams[tournamentId];
    }
  }, [account, tournamentId]);

  const isCaptain = useMemo<boolean>(() => (
    currentTeam?.id == teamId && currentTeam?.player_role === TeamPlayerRoles.CAPTAIN
  ), [currentTeam, teamId]);

  return { account, currentTeam, isCaptain, isLoading };
}

export function useTeamPosition(teams: TournamentDetails['teams'], teamId?: number): number {
  return useMemo(() => (
    (teams && teamId) ? Object.values(teams).findIndex(t => t.id === teamId) + 1 : 0
  ), [teams, teamId]);
}

export function useTeamTags(teams?: TournamentDetails['teams']): TeamTags {
  return useMemo<TeamTags>(() => {
    const tags: TeamTags = new Set();
    if (teams) {
      for (const key in teams) {
        tags.add(teams[key].tag)
      }
    }
    return tags;
  }, [teams]);
}
